var $export = require('./_export');

$export($export.S + $export.F, 'Object', { classof: require('./_classof') });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.object.classof.js
// module id = cz1X
// module chunks = 0 1